import { HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProdutoService } from 'src/app/core/services/http/produto.service';
import { GrupoIntegracaoRequest, GrupoIntegracaoStatusRequest, GrupoIntegracaoViewModel, PlataformaResponse, ProdutoComEmpresaView, ProdutosParaVendaRequest } from 'src/app/shared/models/produto.model';
import { Paginador } from 'src/app/shared/models/paginador.model';
import { AuthenticationService } from 'src/app/core/services/http/authentication.service';
import { PessoaService } from 'src/app/core/services/http/pessoa.service';
import { forkJoin, Subscription, take } from 'rxjs';
import { PessoaModel } from 'src/app/shared/models/pessoa.model';
import { ProdutoIntegracaoService } from 'src/app/core/services/behavior/produto-integracao.service';
import { CastModelUtils } from 'src/app/shared/utils/CastModelUtils';
import { CadastroPerguntasService } from 'src/app/core/services/behavior/cadastro-perguntas.service';
import { CadastroAdicionaisService } from 'src/app/core/services/behavior/cadastro-adicionais.service';

@Component({
    selector: 'app-integracaoprodutos',
    templateUrl: './integracaoprodutos.page.html',
    styleUrls: ['./integracaoprodutos.page.scss'],
})
export class IntegracaoProdutosComponent implements OnDestroy, OnInit {
    @ViewChild('container') container: any;
    @ViewChild('paginadorElement') paginadorElement: any;
    @ViewChild('containerTabela') containerTabela: any;

    public produtos: ProdutoComEmpresaView[] = [];
    public produtosFiltrados: ProdutoComEmpresaView[] = [];
    public plataformas: PessoaModel[] = [];
    public plataformasFiltradas: PessoaModel[] = [];
    public grupos: GrupoIntegracaoViewModel[] = [];
    public gruposFiltrados: GrupoIntegracaoViewModel[] = [];
    private subs$: Subscription[] = [];
    public seletorTipo: 'produto' | 'grupo' = 'produto';
    public seletorPlataforma: number = 0;
    public seletorGrupo: number = 0;
    public termoPesquisa: string = '';
    public codigoPlataformaSelecionada: number = 0;
    public paginador = new Paginador(0, 48, 0);
    public produtosPorPagina: ProdutoComEmpresaView[] = [];
    public grupoPorPagina: GrupoIntegracaoViewModel[] = [];
    public indexItemSelecionado: number = -1;
    public inpFocado: boolean = false;
    public grupoSelPerguntas: GrupoIntegracaoViewModel = null;
    public grupoSelAdicionais: GrupoIntegracaoViewModel = null;
    public somenteUmaEmpresa: boolean = false;
    public titulo: string = "Integração de produtos";

    constructor(
        private produtoService: ProdutoService,
        private router: Router,
        private authService: AuthenticationService,
        private pessoaService: PessoaService,
        private produtoIntegracaoService: ProdutoIntegracaoService,
        private cadastroPerguntasService: CadastroPerguntasService,
        private cadastroAdicionaisService: CadastroAdicionaisService
    ) {}

    ngOnInit(): void {
        setTimeout(() => {
            this.carregarPaginador();
            this.carregarPaginas();
        }, 500);
    }

    ionViewWillEnter() {
        this.recuperarProdutosEGrupos();
    }

    ngOnDestroy() {
        this.subs$.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    @HostListener('document:keydown', ['$event'])
    keydown(event: KeyboardEvent) {
        if (!this.inpFocado) {
            switch (event.key) {
                case 'ArrowLeft':
                    this.alterarPagina(this.paginador.paginaAtual - 1);
                    break;
                case 'ArrowRight':
                    this.alterarPagina(this.paginador.paginaAtual + 1)
                    break;
                case 'ArrowUp':
                    this.alterarItemSelecionado(this.indexItemSelecionado - 1);
                    break;
                case 'ArrowDown':
                    this.alterarItemSelecionado(this.indexItemSelecionado + 1);
            }
        }
    }

    @HostListener('document:focusin', ['$event'])
    focusin(event: FocusEvent) {
        if (event.target instanceof HTMLInputElement) this.inpFocado = true;
    }

    @HostListener('document:focusout', ['$event'])
    focusout(event: FocusEvent) {
        if (event.target instanceof HTMLInputElement) this.inpFocado = false;
    }

    public carregarPaginador() {
        const tamanhoDisplay = this.containerTabela.nativeElement.offsetHeight - 60;
        this.paginador = new Paginador(tamanhoDisplay, 48, 1);
    }

    public home() {
        this.router.navigate(['home']);
    }

    private adicionarPlataformaTodasIntegracoes() {
        this.plataformas.unshift({ bairro: '', celulares: [], cidade: '', codigo: 0, endereco: '', enderecos: [], nome: 'TODAS AS INTEGRAÇÕES', numero: '', pontoRef: '', pontoReferencia: '' })
        this.plataformasFiltradas = this.plataformas.map((plataforma) => CastModelUtils.ClonarObjetoComPropriedadesIguais(plataforma, new PlataformaResponse()));
    }

    private recuperarProdutosEGrupos() {
        const sub = forkJoin({
            produtosIntegracao: this.produtoIntegracaoService.produtosIntegracao.asObservable().pipe(take(1)),
            gruposIntegracao: this.produtoIntegracaoService.gruposIntegracao.asObservable().pipe(take(1)),
        }).subscribe({
            next: ({ produtosIntegracao, gruposIntegracao }) => {
                if (produtosIntegracao === null || gruposIntegracao === null) {
                    this.carregarProdutosEGrupos();
                    return;
                } else {                    
                    this.produtos = produtosIntegracao;
                    this.grupos = gruposIntegracao;

                    this.carregarPaginas();
                    this.pesquisar(this.termoPesquisa);
                }
            },
            error: () => {
                console.log('Error ao recuperar produtos');
            }
        });

        this.subs$.push(sub);
    }

    private carregarProdutosEGrupos() {
        const sub = this.authService.isAuthenticated.subscribe((autenticado) => {            
            if (!autenticado) return;
            this.carregarProdutos();
        });

        this.subs$.push(sub);
    }

    private carregarProdutos() {
        forkJoin({
            produtosIntegracao: this.produtoService.getAllProdutosIntegracao().pipe(take(1)),
            empresasIntegracao: this.pessoaService.getEmpresasIntegracao().pipe(take(1)),
            gruposIntegracao: this.produtoService.getAllGruposIntegracao().pipe(take(1)),
        }).subscribe({
            next: ({ produtosIntegracao: resProdutosIntegracao, empresasIntegracao: resEmpresasIntegracao, gruposIntegracao: resGruposIntegracao }) => {
                const _produtos = resProdutosIntegracao.data.produtosComEmpresas ? resProdutosIntegracao.data.produtosComEmpresas : [];

                let _grupos: GrupoIntegracaoViewModel[] = resGruposIntegracao.data ? resGruposIntegracao.data.map((grupo) => CastModelUtils.ClonarObjetoComPropriedadesIguais(grupo, new GrupoIntegracaoViewModel())) : [];

                _grupos = _grupos.filter(g => g.nome.toUpperCase() !== "COMPLEMENTO DE PEDIDO" && g.nome.toUpperCase() !== "SERVICOS" && g.nome.toUpperCase() !== "INDEFINIDO");

                this.plataformas = resEmpresasIntegracao.data ? resEmpresasIntegracao.data : [];

                _produtos.forEach((produto) => {
                    const produtoView: ProdutoComEmpresaView = CastModelUtils.ClonarObjetoComPropriedadesIguais(produto, new ProdutoComEmpresaView());

                    produtoView.dataChanged = false;

                    this.produtos.push(produtoView);
                    this.produtosFiltrados.push(produtoView);
                });

                _grupos.forEach((grupo) => {
                    grupo.carregarValoresIniciais();

                    this.grupos.push(grupo);
                    this.gruposFiltrados.push(grupo);
                });

                this.produtoIntegracaoService.produtosIntegracao.next(this.produtos);
                this.produtoIntegracaoService.gruposIntegracao.next(this.grupos);                

                this.carregarPaginas();
                
                const empresasFiltradas = this.plataformas.filter((p) => p.nome !== "TODAS AS INTEGRAÇÕES");
                this.somenteUmaEmpresa = empresasFiltradas.length <= 1;
                
                if (this.somenteUmaEmpresa) {
                    const codigo = this.plataformas[0].codigo;
                    
                    this.seletorPlataforma = codigo
                    this.filtrarPlataforma(codigo);
                } else {
                    this.adicionarPlataformaTodasIntegracoes();
                }
            }, error: (err) => {
                console.log('Error ao carregar produtos e grupos de integração', err);
            }, complete: () => {
                console.log('Carregamento de produtos e grupos de integração completo');
            }
        });
    }

    public alterarGrupo(grupo: GrupoIntegracaoViewModel) {
        grupo = Object.assign(new GrupoIntegracaoViewModel(), grupo);

        if (grupo.ouveMundaca()) {
            const grupoRequest = new GrupoIntegracaoRequest();

            grupoRequest.acrescimoReais = grupo.acrescimoReais;
            grupoRequest.checked = grupo.checked;
            grupoRequest.codigo = grupo.codigo;
            grupoRequest.acrescimoPorcento = grupo.acrescimoPorcento;
            grupoRequest.truncarValorVenda = grupo.truncarValorVenda;
            grupoRequest.codigoPessoaIntegracao = grupo.codigoPessoaIntegracao;
            grupoRequest.nomePessoaIntegracao = grupo.nomePessoaIntegracao;
            grupoRequest.codigoFamilia = grupo.codigoFamilia;

            let grupoEncontrado = this.grupos.find((g) => g.codigo === grupo.codigo);
            grupoEncontrado.usarValoresIniciais();

            this.pesquisar(this.termoPesquisa);

            this.produtoService.updateGrupoIntegracao(grupoRequest).subscribe((res) => {
                if (res.success) {
                    Object.assign(grupoEncontrado, grupo);
                    grupoEncontrado.carregarValoresIniciais();

                    this.pesquisar(this.termoPesquisa);
                }
            });
        }
    }

    public alterarStatusGrupo(grupo: GrupoIntegracaoViewModel) {
        const grupoRequest = new GrupoIntegracaoStatusRequest();

        grupoRequest.codigo = grupo.codigo;
        grupoRequest.checked = grupo.checked;
        grupoRequest.codigoFamilia = grupo.codigoFamilia;
        grupoRequest.codigoPessoaIntegracao = grupo.codigoPessoaIntegracao;

        this.produtoService.alterarStatusGrupoIntegracao(grupoRequest).subscribe((res) => {
        });
    }

    public alterarStatusProduto(produto: ProdutoComEmpresaView) {
        const produtoRequest = new ProdutosParaVendaRequest();

        if (produto.dataChanged) {
            produtoRequest.checked = produto.checked;
            produtoRequest.produtoIntegracaoId = produto.codigoIntegracao;
            produtoRequest.codigoProduto = produto.codigo;
            produtoRequest.codigoPessoaIntegracao = produto.codigoPessoaEmpresaIntegracao;
            produtoRequest.acrescimoReais = produto.acrescimoReais;
            produtoRequest.acrescimoPorCento = produto.acrescimoPorCento;
            produtoRequest.precoFinal = produto.precoIntegracao;
            produtoRequest.truncarValorVenda = produto.truncarValorVenda;
            produtoRequest.permitirObs = produto.permitirObs;
        }

        this.produtoService.updateProdutosIntegracao(produtoRequest).subscribe({
            next: (res) => {
                if (res.success) {
                    produto.dataChanged = false;
                }
            }
        });
    }

    private ultimaExecucao = new Map<string, number>();

    /**
     * Verifica se pode executar a ação para a lista de produtos
     */
    private podeExecutar(produto: ProdutoComEmpresaView, intervaloMs = 200): boolean {
        const chave = JSON.stringify(produto.codigo);
        const agora = Date.now();

        const ultimaVez = this.ultimaExecucao.get(chave) || 0;
        if (agora - ultimaVez < intervaloMs) {
            return false;
        }

        this.ultimaExecucao.set(chave, agora);
        return true;
    }

    public alterarValorProduto(produto: ProdutoComEmpresaView) {
        if (!this.podeExecutar(produto)) {
            return;
        }

        const produtoRequest = new ProdutosParaVendaRequest();

        if (produto.dataChanged) {
            produtoRequest.codigoProduto = produto.codigo;
            produtoRequest.codigoPessoaIntegracao = produto.codigoPessoaEmpresaIntegracao;

            produtoRequest.acrescimoPorCento = produto.acrescimoPorCento;
            produtoRequest.acrescimoReais = produto.acrescimoReais;

            if (produtoRequest.acrescimoPorCento > 0) {
                produtoRequest.acrescimoReais = 0;
            }

            produtoRequest.precoFinal = produto.precoIntegracao;
            produtoRequest.checked = produto.checked;
            produtoRequest.produtoIntegracaoId = produto.codigoIntegracao;

            this.produtoService.updateProdutosIntegracao(produtoRequest).subscribe({
                next: (res) => {
                    if (res.success) {
                        produto.dataChanged = false;
                    }
                }
            });
        }
    }

    public alterarItemSelecionado(index: number) {
        if (index === this.indexItemSelecionado) {
            return;
        }

        if (index < 0) {
            if (this.paginador.paginaAtual === 1) {
                this.indexItemSelecionado = -1;
            } else {
                this.alterarPagina(this.paginador.paginaAtual - 1);
                this.indexItemSelecionado = this.paginador.qtdItensPagina - 1;
            }

            return;
        }

        if (index >= this.paginador.qtdItensPagina) {
            this.indexItemSelecionado = 0;
            this.alterarPagina(this.paginador.paginaAtual + 1);
            return;
        }

        switch (this.seletorTipo) {
            case 'produto':
                if (index >= this.produtosPorPagina.length) {
                    this.indexItemSelecionado = this.produtosPorPagina.length - 1;
                    return;
                }

                break;
            case 'grupo':
                if (index >= this.grupoPorPagina.length) {
                    this.indexItemSelecionado = this.grupoPorPagina.length - 1;
                    return;
                }
        }

        this.indexItemSelecionado = index;
    }

    private calcularTotalPaginas() {
        switch (this.seletorTipo) {
            case 'grupo':
                this.paginador.calcularTotalPaginas(this.gruposFiltrados.length);
                break;
            case 'produto':
                this.paginador.calcularTotalPaginas(this.produtosFiltrados.length);
        }
    }

    public carregarPaginas() {
        this.calcularTotalPaginas();

        switch (this.seletorTipo) {
            case 'grupo':
                this.grupoPorPagina = this.paginador.paginar(this.gruposFiltrados);
                break;
            case 'produto':
                this.produtosPorPagina = this.paginador.paginar(this.produtosFiltrados);
        }
    }

    public alterarPagina(pagina: number) {
        if (pagina > this.paginador.totalPaginas || pagina < 1) {
            return;
        }

        this.paginador.paginaAtual = pagina;
        this.carregarPaginas();
    }

    public pesquisar(termo: string) {
        switch (this.seletorTipo) {
            case 'grupo':
                let gruposFiltrados = [];

                if (this.codigoPlataformaSelecionada != 0) {
                    gruposFiltrados = this.grupos.filter((grupo) => grupo.nome.toLowerCase().includes(termo) && grupo.codigoPessoaIntegracao === this.codigoPlataformaSelecionada);
                } else {
                    gruposFiltrados = this.grupos.filter((grupo) => grupo.nome.toLowerCase().includes(termo));
                }

                this.gruposFiltrados = gruposFiltrados;

                break;
            case 'produto':
                let produtosFiltrados = [];

                if (this.codigoPlataformaSelecionada != 0) {
                    produtosFiltrados = this.produtos.filter((produto) => produto.nome.toLowerCase().includes(termo) && produto.codigoPessoaEmpresaIntegracao === this.codigoPlataformaSelecionada);
                } else {
                    produtosFiltrados = this.produtos.filter((produto) => produto.nome.toLowerCase().includes(termo));
                }

                this.produtosFiltrados = produtosFiltrados;
        }

        this.carregarPaginas();
        this.indexItemSelecionado = 0;
    }

    public filtrarPlataforma(codigoPlataforma: number) {
        this.codigoPlataformaSelecionada = codigoPlataforma;

        switch (this.seletorTipo) {
            case 'grupo':
                if (codigoPlataforma == 0) {
                    this.gruposFiltrados = this.grupos.map((grupo) => CastModelUtils.ClonarObjetoComPropriedadesIguais(grupo, new GrupoIntegracaoViewModel()));
                } else {
                    const gruposFiltrados = this.grupos.filter((grupo) => grupo.codigoPessoaIntegracao === codigoPlataforma);
                    this.gruposFiltrados = gruposFiltrados.map((grupo) => CastModelUtils.ClonarObjetoComPropriedadesIguais(grupo, new GrupoIntegracaoViewModel()));
                }
                break;
            case 'produto':
                if (codigoPlataforma == 0) {
                    this.produtosFiltrados = this.produtos.map((produto) => CastModelUtils.ClonarObjetoComPropriedadesIguais(produto, new ProdutoComEmpresaView()));
                    this.carregarPaginas();

                } else {
                    const produtosFiltrados = this.produtos.filter((produto) => produto.codigoPessoaEmpresaIntegracao === codigoPlataforma);
                    this.produtosFiltrados = produtosFiltrados.map((produto) => CastModelUtils.ClonarObjetoComPropriedadesIguais(produto, new ProdutoComEmpresaView()));;
                }
        }

        this.pesquisar(this.termoPesquisa);
        this.carregarPaginas();
        this.indexItemSelecionado = -1;
    }

    public alterarSeletorTipo() {
        this.indexItemSelecionado = -1;
        this.alterarPagina(1);

        this.seletorPlataforma = 0;
        this.carregarPaginas();

        switch (this.seletorTipo) {
            case 'produto':
                this.plataformasFiltradas = [...this.plataformas];
                break;
            case 'grupo':
                this.plataformasFiltradas = [...this.plataformas];
        }

        this.filtrarPlataforma(this.seletorPlataforma)
    }

    public limparPesquisa() {
        this.termoPesquisa = '';
        this.pesquisar('');
    }

    public fecharValoresGrupo() {
        this.titulo = "Integração de produtos";
        this.grupoSelPerguntas = null;
        this.grupoSelAdicionais = null;
    }

    public abrirPerguntasGrupo(grupo: GrupoIntegracaoViewModel) {
        this.grupoSelPerguntas = grupo;

        this.titulo = "Perguntas - " + grupo.nome;
        
        this.cadastroPerguntasService.codigoFamilia.next(this.grupoSelPerguntas.codigoFamilia);
    }

    public abrirAdicionaisGrupo(grupo: GrupoIntegracaoViewModel) {
        this.grupoSelAdicionais = grupo;

        this.titulo = "Adicionais - " + grupo.nome;
        
        this.cadastroAdicionaisService.codigoFamilia.next(this.grupoSelAdicionais.codigoFamilia);
        this.cadastroAdicionaisService.nomeGrupo.next(this.grupoSelAdicionais.nome);
    }
}
